import React from 'react'

const ICON_PATHS: Record<string, string> = {
  // Navigation
  calendar:  'M3 8h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM8 2v4M16 2v4',
  home:      'M3 11l9-8 9 8M5 9v11h14V9',
  briefcase: 'M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9zM8 9V6a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v3',
  layers:    'M12 3l9 5-9 5-9-5 9-5zM3 14l9 5 9-5M3 19l9 5 9-5',
  grid:      'M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z',
  list:      'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
  map:       'M9 4v15l-6 2V6l6-2zM15 6v15l-6-2V4l6 2zM21 4v15l-6 2V6l6-2z',
  // State
  check:     'M5 12l5 5L20 7',
  x:         'M6 6l12 12M18 6L6 18',
  plus:      'M12 5v14M5 12h14',
  refresh:   'M3 12a9 9 0 0 1 15.5-6.3L21 8M21 3v5h-5M21 12a9 9 0 0 1-15.5 6.3L3 16M3 21v-5h5',
  clock:     'M12 7v5l3 2M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z',
  flag:      'M4 22V4M4 4h13l-2 4 2 4H4',
  // Direction
  chevR:     'M9 6l6 6-6 6',
  chevD:     'M6 9l6 6 6-6',
  chevL:     'M15 6l-6 6 6 6',
  chevU:     'M6 15l6-6 6 6',
  arrowR:    'M5 12h14M13 6l6 6-6 6',
  swap:      'M16 3l4 4-4 4M20 7H8M8 21l-4-4 4-4M4 17h12',
  // I/O
  search:    'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm10 2l-4.3-4.3',
  filter:    'M3 4h18l-7 9v7l-4-2v-5L3 4z',
  bell:      'M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10 21a2 2 0 0 0 4 0',
  user:      'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  // Content
  paperclip: 'M21 11l-9 9a5 5 0 0 1-7-7l9-9a3.5 3.5 0 0 1 5 5l-9 9a2 2 0 0 1-3-3l8-8',
  msg:       'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10z',
  link:      'M9 17H7A5 5 0 0 1 7 7h2M15 7h2a5 5 0 0 1 0 10h-2M8 12h8',
  // Open the record on its own page (related-work card secondary action).
  external:  'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3',
  trash:     'M4 7h16M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13',
  download:  'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3',
  sparkles:  'M12 3v3M12 18v3M5 12H2M22 12h-3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1',
  lock:      'M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2zM7 11V7a5 5 0 0 1 10 0v4',
  // Finish Schedule — stacked swatch cards (finishes / selections / specs).
  swatches:  'M8 3h11a2 2 0 0 1 2 2v11M5 7h11a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z',
}

const ICON_NODES: Record<string, React.ReactNode> = {
  more: <><circle cx="12" cy="5" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="12" cy="19" r="1.5"/></>,
}

export interface IconProps {
  name: string
  size?: number
  sw?: number
  style?: React.CSSProperties
  className?: string
}

export function Icon({ name, size = 18, sw = 1.6, style, className, ...rest }: IconProps) {
  const isFilled = !!ICON_NODES[name]
  const path = ICON_PATHS[name]
  if (!path && !isFilled) {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24"
        style={{ flexShrink: 0, ...style }} className={className}
        aria-label={`icon-missing:${name}`}>
        <rect x="2" y="2" width="20" height="20" fill="none" stroke="#E14B4B" strokeWidth="1.5" strokeDasharray="2 2"/>
        <line x1="2" y1="2" x2="22" y2="22" stroke="#E14B4B" strokeWidth="1.5"/>
      </svg>
    )
  }
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24"
      fill={isFilled ? 'currentColor' : 'none'}
      stroke={isFilled ? 'none' : 'currentColor'}
      strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round"
      style={{ flexShrink: 0, ...style }}
      className={className}
      aria-hidden="true"
      {...rest}>
      {isFilled ? ICON_NODES[name] : <path d={path}/>}
    </svg>
  )
}

export { ICON_PATHS, ICON_NODES }
